import { useNavigate } from 'react-router-dom';

import { Button } from '@revelio/ui';

import styles from './page-not-found.module.css';

/**
 * Displays a 404 message for missing Custom Dash pages.
 * Quick access to landing page.
 */
export const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.center}>
      <div className={styles.stack}>
        <p className={styles.title}>Page Not Found</p>
        <p className={styles.body}>
          The page you are looking for has been moved or deleted.
        </p>
        <Button color="primary" onClick={() => navigate('/')}>
          Go to Landing Page
        </Button>
      </div>
    </div>
  );
};
